<template>
    <div class="tool-bar" :class="{'fixed': isFixed}">
        <div class="tool-bar-wrap">
            <search-bar ></search-bar>
            <div class="group">
                <router-link style="margin-right: 16px" :to="{ name: 'Faq'}">
                    <img :src="menuList[0].img.now" alt="" @mouseenter="menuList[0].img.now = menuList[0].img.hover" @mouseleave="menuList[0].img.now = menuList[0].img.default" srcset="">
                    <div class="tip">
                        {{menuList[0].title}}
                    </div>
                </router-link>
                <!-- <message-alarm></message-alarm> -->
                <user-menu></user-menu>
            </div>
        </div>
        
    </div>
</template>
<script>
import SearchBar from '@/components/landlord/SearchBar.vue';
import UserMenu from '@/components/landlord/UserMenu.vue';
import MessageAlarm from '@/components/landlord/MessageAlarm.vue';

export default {
    data () {
        return {
            isFixed: false,
            menuList: [
                {
                    img:{
                        now: require('@/assets/img/component/menu/question_gray.svg'),
                        default: require('@/assets/img/component/menu/question_gray.svg'),
                        hover: require('@/assets/img/component/menu/question_green.svg')
                    },
                    title: '常見問題'
                },
            ]
        }
    },
    mounted () { 
        this.updateList() 
    },
    watch: { 
        '$route' () { 
            this.updateList() 
        } 
    },
    methods: {
        updateList () { 
            if(this.$route.meta.isFixed){
                this.isFixed = true
            }else{
                this.isFixed = false
            }
        }
    },
    components: {
        SearchBar,
        UserMenu,
        MessageAlarm
    }
}
</script>
<style lang="scss" scoped>
    .tool-bar{
        position: relative;
        width: 100%;
        .tool-bar-wrap{
            position: relative;
            display: flex;
            align-items: center;
            height: 80px;
            right: -1px;
            background: #fff;
            // border-bottom: 1px solid #f0f0f0;
            .group{
                position: relative;
                display: flex;
                align-items: center;
                a{
                    position: relative;
                    .tip{
                        position: absolute;
                        background: url('../../assets/img/component/header/tips.svg');
                        width: 80px;
                        height: 40px;
                        left: -25px;
                        top: 38px;
                        color: #fff;
                        display: none;
                        align-items: center;
                        justify-content: center;
                    }
                }
                a:hover{
                    .tip{
                        display: flex;
                    }
                }
            }
        }
        
    }   
    .tool-bar.fixed{
        position: fixed;
        z-index: 9;
    } 
    @media screen and (max-width: 1280px) {
        .tool-bar{
            width: 1180px;
            .tool-bar-wrap{
                width: 100%;
                right: -6px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/ToolBar.vue